import React, { FC, PropsWithChildren, createContext } from 'react'

const SatoshiContext = createContext<any>(null)

const SatoshiManager: FC<PropsWithChildren> = (props) => {
	const [showUSD, setShowUSD] = React.useState(true)

	return (
		<SatoshiContext.Provider value={{ showUSD, setShowUSD }}>
			{props.children}
		</SatoshiContext.Provider>
	)
}

export default SatoshiManager
